(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[370,8888],{

/***/ 10285:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d/,r=/\d\d/,i=/\d\d?/,o=/\d*[^-_:/,()\s\d]+/,s={},a=function(e){return(e=+e)+(e>68?1900:2e3)};var f=function(e){return function(t){this[e]=+t}},h=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e)}],u=function(e){var t=s[e];return t&&(t.indexOf?t:t.s.concat(t.f))},d=function(e,t){var n,r=s.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},c={A:[o,function(e){this.afternoon=d(e,!1)}],a:[o,function(e){this.afternoon=d(e,!0)}],Q:[n,function(e){this.month=3*(e-1)+1}],S:[n,function(e){this.milliseconds=100*+e}],SS:[r,function(e){this.milliseconds=10*+e}],SSS:[/\d{3}/,function(e){this.milliseconds=+e}],s:[i,f("seconds")],ss:[i,f("seconds")],m:[i,f("minutes")],mm:[i,f("minutes")],H:[i,f("hours")],h:[i,f("hours")],HH:[i,f("hours")],hh:[i,f("hours")],D:[i,f("day")],DD:[r,f("day")],Do:[o,function(e){var t=s.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r)}],w:[i,f("week")],ww:[r,f("week")],M:[i,f("month")],MM:[r,f("month")],MMM:[o,function(e){var t=u("months"),n=(u("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n}],MMMM:[o,function(e){var t=u("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t}],Y:[/[+-]?\d+/,f("year")],YY:[r,function(e){this.year=a(e)}],YYYY:[/\d{4}/,f("year")],Z:h,ZZ:h};function l(n){var r,i;r=n,i=s&&s.formats;for(var o=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=o.length,f=0;f<a;f+=1){var h=o[f],u=c[h],d=u&&u[0],l=u&&u[1];o[f]=l?{regex:d,parser:l}:h.replace(/^\[|\]$/g,"")}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=o[n];if("string"==typeof i)r+=i.length;else{var s=i.regex,f=i.parser,h=e.slice(r),u=s.exec(h)[0];f.call(t,u),e=e.replace(u,"")}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(a=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,o=e.args;this.$u=r;var a=o[1];if("string"==typeof a){var f=!0===o[2],h=!0===o[3],u=f||h,d=o[2];h&&(d=o[2]),s=this.$locale(),!f&&d&&(s=n.Ls[d]),this.$d=function(e,t,n,r){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var i=l(t)(e),o=i.year,s=i.month,a=i.day,f=i.hours,h=i.minutes,u=i.seconds,d=i.milliseconds,c=i.zone,m=i.week,M=new Date,Y=a||(o||s?1:M.getDate()),p=o||M.getFullYear(),v=0;o&&!s||(v=s>0?s-1:M.getMonth());var D,w=f||0,g=h||0,y=u||0,L=d||0;return c?new Date(Date.UTC(p,v,Y,w,g,y,L+60*c.offset*1e3)):n?new Date(Date.UTC(p,v,Y,w,g,y,L)):(D=new Date(p,v,Y,w,g,y,L),m&&(D=r(D).week(m).toDate()),D)}catch(e){return new Date("")}}(t,a,r,n),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),s={}}else if(a instanceof Array)for(var c=a.length,m=1;m<=c;m+=1){o[1]=a[m-1];var M=n.apply(this,o);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===c&&(this.$d=new Date(""))}else i.call(this,e)}}}));

/***/ }),

/***/ 37412:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i){i.prototype.isSameOrBefore=function(e,i){return this.isSame(e,i)||this.isBefore(e,i)}}}));

/***/ }),

/***/ 62173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ArticlePublisher; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_dateHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78219);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90664);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var ArticlePublisher = function(param) {
    var author = param.author, publishedDate = param.publishedDate, fontColor = param.fontColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().publish), fontColor && (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[fontColor]),
        children: [
            "Article by ",
            author === null || author === void 0 ? void 0 : author.name,
            " |",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().date),
                children: (0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_1__/* .parseAndFormatDate */ .PN)(publishedDate, "DD MMM YYYY")
            })
        ]
    });
};


/***/ }),

/***/ 14649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ArticleSnippet": function() { return /* binding */ ArticleSnippet; },
  "ArticleSnippetStyle": function() { return /* binding */ ArticleSnippetStyle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/index.tsx + 1 modules
var ChildrenContainer = __webpack_require__(38628);
// EXTERNAL MODULE: ./components/CMS/ImageSlider/index.tsx + 1 modules
var ImageSlider = __webpack_require__(8859);
// EXTERNAL MODULE: ./components/CMS/constants.ts
var constants = __webpack_require__(3379);
// EXTERNAL MODULE: ./components/CMS/style.module.scss
var style_module = __webpack_require__(88415);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./components/CMS/CmsImage/index.ts + 2 modules
var CmsImage = __webpack_require__(78868);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/CMS/ArticlePublisher/index.tsx
var ArticlePublisher = __webpack_require__(62173);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var Image = __webpack_require__(87113);
// EXTERNAL MODULE: ./components/CMS/ArticleSnippet/ArticleSnippetItem/style.module.scss
var ArticleSnippetItem_style_module = __webpack_require__(30353);
var ArticleSnippetItem_style_module_default = /*#__PURE__*/__webpack_require__.n(ArticleSnippetItem_style_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleSnippet/ArticleSnippetItem/index.tsx











var ArticleSnippetItem = function(param) {
    var article = param.article, withBackground = param.withBackground, gridDirection = param.gridDirection, style = param.style;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((ArticleSnippetItem_style_module_default()).container, style && (ArticleSnippetItem_style_module_default())[style], withBackground && (ArticleSnippetItem_style_module_default())["".concat(style, "_BG")], withBackground && (ArticleSnippetItem_style_module_default()).containerBG),
        children: article && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            direction: gridDirection !== null && gridDirection !== void 0 ? gridDirection : "column",
            spacing: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArticleSnippetItem_style_module_default()).cover,
                        children: (article === null || article === void 0 ? void 0 : article.cover) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsImage/* default */.Z, {
                                    altText: article.cover.alternativeText || Image/* defaultAlt */.Zp,
                                    imageProps: article.cover,
                                    format: "small",
                                    layout: "intrinsic",
                                    width: 940,
                                    height: 540
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ArticleSnippetItem_style_module_default()).topLeft,
                                    children: (ref = article.article_category) === null || ref === void 0 ? void 0 : ref.name
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ArticleSnippetItem_style_module_default()).info,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ArticleSnippetItem_style_module_default()).title,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    prefetch: false,
                                    href: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
                                    as: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (ArticleSnippetItem_style_module_default()).link,
                                        href: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article === null || article === void 0 ? void 0 : article.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h1",
                                            component: "h5",
                                            children: article.title
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ArticleSnippetItem_style_module_default()).blurb,
                                children: article.blurb
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePublisher/* ArticlePublisher */.n, {
                                author: article.author,
                                publishedDate: article.published_date
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ArticleSnippet_ArticleSnippetItem = (ArticleSnippetItem);

// EXTERNAL MODULE: ./components/CMS/ArticleSnippet/style.module.scss
var ArticleSnippet_style_module = __webpack_require__(16944);
var ArticleSnippet_style_module_default = /*#__PURE__*/__webpack_require__.n(ArticleSnippet_style_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleSnippet/index.tsx











var BackgroundBannerImage = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4421).then(__webpack_require__.bind(__webpack_require__, 44421)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44421)
            ];
        }
    }
});
var ArticleSnippetStyle;
(function(ArticleSnippetStyle) {
    ArticleSnippetStyle["FullWidth"] = "Full_Width";
    ArticleSnippetStyle["Vertical"] = "One_Column";
    ArticleSnippetStyle["TwoColumns"] = "Two_Column";
    ArticleSnippetStyle["ThreeColumns"] = "Three_Column";
    ArticleSnippetStyle["SlidesShow"] = "Slides_Show";
})(ArticleSnippetStyle || (ArticleSnippetStyle = {}));
var styleToGridColumn = function(style) {
    switch(style){
        case ArticleSnippetStyle.ThreeColumns:
            return 4;
        case ArticleSnippetStyle.TwoColumns:
            return 6;
        default:
            return 12;
    }
};
var styleToGridDirection = function(style) {
    switch(style){
        case ArticleSnippetStyle.TwoColumns:
        case ArticleSnippetStyle.ThreeColumns:
            return constants/* GridDirection.Column */.mp.Column;
        default:
            return constants/* GridDirection.Row */.mp.Row;
    }
};
var ArticleSnippet = function(param) {
    var background = param.background, heading = param.heading, articles = param.articles, article = param.article, _layout = param.layout, layout = _layout === void 0 ? ArticleSnippetStyle.FullWidth : _layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: background ? classnames_default()((ArticleSnippet_style_module_default()).bgImage, (ArticleSnippet_style_module_default())[layout], (ArticleSnippet_style_module_default())["".concat(layout, "_BG")]) : (ArticleSnippet_style_module_default())[layout],
        children: [
            background && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundBannerImage, {
                className: classnames_default()((ArticleSnippet_style_module_default()).background)
            }),
            layout === ArticleSnippetStyle.SlidesShow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    heading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArticleSnippet_style_module_default()).title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            children: heading
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider["default"], {
                        articles: articles
                    })
                ]
            }) : null,
            layout !== ArticleSnippetStyle.SlidesShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChildrenContainer/* default */.Z, {
                children: [
                    article ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: background ? classnames_default()((ArticleSnippet_style_module_default()).bgImage, (style_module_default()).containerPaddingS) : (style_module_default()).containerMarginS,
                        children: [
                            heading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ArticleSnippet_style_module_default()).title,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        children: heading
                                    }),
                                    background ? /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: (ArticleSnippet_style_module_default()).line
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSnippet_ArticleSnippetItem, {
                                article: article,
                                withBackground: background,
                                style: ArticleSnippetStyle.FullWidth,
                                gridDirection: styleToGridDirection(layout)
                            })
                        ]
                    }) : null,
                    articles ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: background ? classnames_default()((ArticleSnippet_style_module_default()).bgImage, (style_module_default()).containerPaddingS) : (style_module_default()).containerMarginS,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ArticleSnippet_style_module_default())[layout],
                            children: [
                                heading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ArticleSnippet_style_module_default()).title,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            children: heading
                                        }),
                                        background && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: (ArticleSnippet_style_module_default()).line
                                        })
                                    ]
                                }) : null,
                                layout === ArticleSnippetStyle.ThreeColumns || layout === ArticleSnippetStyle.TwoColumns || layout === ArticleSnippetStyle.Vertical ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    container: true,
                                    spacing: 3,
                                    className: (ArticleSnippet_style_module_default()).articles,
                                    children: articles.map(function(articleData) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: styleToGridColumn(layout),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSnippet_ArticleSnippetItem, {
                                                article: articleData,
                                                withBackground: background,
                                                gridDirection: styleToGridDirection(layout),
                                                style: layout
                                            })
                                        }, articleData.id);
                                    })
                                }) : null
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 38628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ CMSChildrenContainer; },
  "Z": function() { return /* binding */ ChildrenContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/stylesHelper.ts
// Future improvement could be to add baseClasses as a potential array - either array or string
// if (Array.isArray(baseClass)) { return [...baseClass, className].join(" ")
function combineClasses(baseClass, className) {
    return className ? "".concat(baseClass, " ").concat(className) : baseClass;
}

// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/style.module.scss
var style_module = __webpack_require__(88460);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ChildrenContainer/index.tsx




var CMSChildrenContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: combineClasses((style_module_default()).childrenContainer, className),
        children: children
    });
};
/* harmony default export */ var ChildrenContainer = (CMSChildrenContainer);


/***/ }),

/***/ 78868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CmsImage_CmsImage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/CMS/CmsImage/getImageUrl.ts
var getImageUrl = function(imageFormats, smallestImageFormat, fallbackImageUrl) {
    if (!imageFormats) {
        return fallbackImageUrl;
    }
    if (imageFormats[smallestImageFormat]) {
        return imageFormats[smallestImageFormat].url;
    }
    var currentSmallestImageFormat = smallestImageFormat;
    var availableimageFormats = [
        "thumbnail",
        "small",
        "medium",
        "large"
    ];
    while(!imageFormats[currentSmallestImageFormat]){
        if (currentSmallestImageFormat === "large") {
            return fallbackImageUrl;
        }
        currentSmallestImageFormat = availableimageFormats[availableimageFormats.indexOf(currentSmallestImageFormat) + 1];
        if (imageFormats[currentSmallestImageFormat]) {
            return imageFormats[currentSmallestImageFormat].url;
        }
    }
};

;// CONCATENATED MODULE: ./components/CMS/CmsImage/CmsImage.tsx




var CmsImage = function(param) {
    var imageProps = param.imageProps, altText = param.altText, format = param.format, quality = param.quality, layout = param.layout, height = param.height, width = param.width, objectFit = param.objectFit, priority = param.priority, className = param.className, sizes = param.sizes;
    var imageUrl = getImageUrl(imageProps.formats, format, imageProps.url);
    return imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: className,
        alt: altText,
        src: imageUrl,
        priority: priority,
        layout: layout,
        objectFit: objectFit,
        quality: quality,
        height: height,
        width: width,
        sizes: sizes
    }) : null;
};
/* harmony default export */ var CmsImage_CmsImage = (CmsImage);

;// CONCATENATED MODULE: ./components/CMS/CmsImage/index.ts



/***/ }),

/***/ 8859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ImageSlider": function() { return /* binding */ ImageSlider; },
  "default": function() { return /* binding */ CMS_ImageSlider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(16703);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ChevronLeft.js
var ChevronLeft = __webpack_require__(89875);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ChevronRight.js
var ChevronRight = __webpack_require__(66735);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./components/CMS/ImageSlider/ImageSliderItem/style.module.scss
var style_module = __webpack_require__(8825);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ImageSlider/ImageSliderItem/index.tsx









var Markdown = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 724).then(__webpack_require__.t.bind(__webpack_require__, 30724, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30724)
            ];
        }
    }
});
var CoverStyle;
(function(CoverStyle) {
    CoverStyle["Article"] = "article";
    CoverStyle["Testimonial"] = "testimonial";
    CoverStyle["General"] = "general";
})(CoverStyle || (CoverStyle = {}));
var ImageSliderItem = function(param) {
    var testimonial = param.testimonial, article = param.article, generalImageSlider = param.generalImageSlider, order = param.order;
    var ref, ref1, ref2, ref3;
    var ref4, ref5;
    var bgImage = (ref5 = (ref4 = testimonial === null || testimonial === void 0 ? void 0 : (ref = testimonial.image) === null || ref === void 0 ? void 0 : ref.url) !== null && ref4 !== void 0 ? ref4 : article === null || article === void 0 ? void 0 : (ref1 = article.cover) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref5 !== void 0 ? ref5 : generalImageSlider === null || generalImageSlider === void 0 ? void 0 : (ref2 = generalImageSlider.image) === null || ref2 === void 0 ? void 0 : ref2.url;
    var coverStyle = article ? CoverStyle.Article : testimonial ? CoverStyle.Testimonial : CoverStyle.General;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (style_module_default()).container,
        style: {
            backgroundImage: bgImage ? "url(".concat(bgImage, ")") : undefined
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (style_module_default()).bgColor,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((style_module_default()).cover, (style_module_default())[coverStyle]),
                children: [
                    article && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (style_module_default()).order,
                                children: [
                                    "/ ",
                                    order && order < 10 ? "0" + order : order
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                prefetch: false,
                                href: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
                                as: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (style_module_default()).link,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (style_module_default()).title,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: article.title
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (style_module_default()).publish,
                                children: [
                                    (ref3 = article.article_category) === null || ref3 === void 0 ? void 0 : ref3.name,
                                    " /",
                                    " ",
                                    dayjs_min_default()(article.published_date).format("MMMM YYYY")
                                ]
                            })
                        ]
                    }),
                    testimonial && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown, {
                                className: (style_module_default()).quotes,
                                source: testimonial.quote
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (style_module_default()).publish,
                                children: [
                                    testimonial.author_name,
                                    " ",
                                    testimonial.job_title && ", ".concat(testimonial.job_title)
                                ]
                            })
                        ]
                    }),
                    generalImageSlider && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (generalImageSlider === null || generalImageSlider === void 0 ? void 0 : generalImageSlider.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (style_module_default()).general_image_title,
                                children: generalImageSlider.title
                            }),
                            (generalImageSlider === null || generalImageSlider === void 0 ? void 0 : generalImageSlider.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (style_module_default()).btnContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "secondary",
                                    href: generalImageSlider === null || generalImageSlider === void 0 ? void 0 : generalImageSlider.link,
                                    className: (style_module_default()).button,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (style_module_default()).linkText,
                                        children: "Read Article"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (style_module_default()).content,
                                children: generalImageSlider.content
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ImageSlider_ImageSliderItem = (ImageSliderItem);

// EXTERNAL MODULE: ./components/CMS/ImageSlider/style.module.scss
var ImageSlider_style_module = __webpack_require__(84201);
var ImageSlider_style_module_default = /*#__PURE__*/__webpack_require__.n(ImageSlider_style_module);
;// CONCATENATED MODULE: ./components/CMS/ImageSlider/index.tsx











var arrowStyles = {
    top: "calc(50% - 15px)"
};
var ImageSlider = function(param) {
    var testimonials = param.testimonials, articles = param.articles, generalImageSliders = param.generalImageSliders;
    var getConfigurableProps = function() {
        return {
            showArrows: true,
            showStatus: false,
            showIndicators: false,
            infiniteLoop: true,
            showThumbs: false,
            useKeyboardArrows: true,
            autoPlay: false,
            stopOnHover: true,
            className: (ImageSlider_style_module_default()).imageSlider,
            centerSlidePercentage: 60,
            renderItem: function(item, options) {
                if (options === null || options === void 0 ? void 0 : options.isSelected) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ImageSlider_style_module_default()).selected,
                        children: item
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImageSlider_style_module_default()).unselected,
                    children: item
                });
            },
            renderArrowPrev: function(onClickHandler, hasPrev) {
                return hasPrev && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {
                    className: (ImageSlider_style_module_default()).arrowStyle,
                    style: (0,_object_spread/* default */.Z)({}, arrowStyles),
                    onClick: onClickHandler
                });
            },
            renderArrowNext: function(onClickHandler, hasNext) {
                return hasNext && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                    className: (ImageSlider_style_module_default()).arrowStyle,
                    style: (0,_object_spread/* default */.Z)({
                        right: "15px"
                    }, arrowStyles),
                    onClick: onClickHandler
                });
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ImageSlider_style_module_default()).container, (ImageSlider_style_module_default()).containerMarginS, articles ? (ImageSlider_style_module_default()).articleSlides : (ImageSlider_style_module_default()).others),
        children: [
            testimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                centerMode: true
            }, getConfigurableProps()), {
                children: testimonials.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider_ImageSliderItem, {
                        testimonial: item,
                        order: index + 1
                    }, item.id);
                })
            })),
            articles && /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                centerMode: true
            }, getConfigurableProps()), {
                children: articles.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider_ImageSliderItem, {
                        article: item,
                        order: index + 1
                    }, item.slug);
                })
            })),
            generalImageSliders && /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                centerMode: true
            }, getConfigurableProps()), {
                children: generalImageSliders.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider_ImageSliderItem, {
                        generalImageSlider: item
                    }, item.id);
                })
            }))
        ]
    });
};
/* harmony default export */ var CMS_ImageSlider = (ImageSlider);


/***/ }),

/***/ 3379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mp": function() { return /* binding */ GridDirection; },
/* harmony export */   "uj": function() { return /* binding */ LinkStyle; },
/* harmony export */   "v2": function() { return /* binding */ Alignment; }
/* harmony export */ });
/* unused harmony export LayoutBackground */
var LinkStyle;
(function(LinkStyle) {
    LinkStyle["Button"] = "Button";
    LinkStyle["HyperLink"] = "HyperLink";
    LinkStyle["MainCta"] = "MainCTA";
})(LinkStyle || (LinkStyle = {}));
var GridDirection;
(function(GridDirection) {
    GridDirection["Row"] = "row";
    GridDirection["RowReverse"] = "row-reverse";
    GridDirection["Column"] = "column";
    GridDirection["ColumnReverse"] = "column-reverse";
})(GridDirection || (GridDirection = {}));
var Alignment;
(function(Alignment) {
    Alignment["Center"] = "Center";
    Alignment["Left"] = "Left";
    Alignment["Right"] = "Right";
})(Alignment || (Alignment = {}));
var LayoutBackground;
(function(LayoutBackground) {
    LayoutBackground["Dark"] = "Dark";
    LayoutBackground["Light"] = "Light";
})(LayoutBackground || (LayoutBackground = {}));


/***/ }),

/***/ 87113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mo": function() { return /* binding */ ImageContainer; },
  "Zp": function() { return /* binding */ defaultAlt; }
});

// UNUSED EXPORTS: RegisterImgStyle

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/SmallPrintTerms/style.module.scss
var style_module = __webpack_require__(10416);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/SmallPrintTerms/index.tsx






var privacyPolicyUrl = appClientConfig/* appClientConfig.privacyPolicyUrl */.p.privacyPolicyUrl;
var SmallPrintTerms = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (style_module_default()).smallPrint,
        children: [
            "Our",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                as: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                    children: "Terms of Use"
                })
            }),
            " ",
            "and",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: privacyPolicyUrl,
                as: privacyPolicyUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: privacyPolicyUrl,
                    children: "Privacy Policy"
                })
            })
        ]
    });
};
/* harmony default export */ var components_SmallPrintTerms = (SmallPrintTerms);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./components/Image/img/quote.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 52,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.79 46c-3.927 0-7.068-1.42-9.424-4.26C1.122 38.789 0 34.984 0 30.327c0-6.36 1.683-12.096 5.049-17.207C8.526 7.894 13.799 3.52 20.867 0l1.851 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.841 2.555.561.568 1.403.852 2.525.852 2.804 0 5.16 1.023 7.068 3.067 2.019 1.93 3.029 4.316 3.029 7.155 0 2.84-1.01 5.225-3.03 7.156C17.95 45.091 15.595 46 12.79 46Zm29.113 0c-3.927 0-7.068-1.42-9.424-4.26-2.244-2.952-3.366-6.757-3.366-11.414 0-6.36 1.683-12.096 5.049-17.207C37.64 7.894 42.912 3.52 49.98 0l1.85 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.842 2.555.56.568 1.402.852 2.524.852 2.805 0 5.16 1.023 7.068 3.067C50.99 30.893 52 33.279 52 36.118c0 2.84-1.01 5.225-3.03 7.156C47.065 45.091 44.709 46 41.904 46Z",
    fill: "#C0E8FF"
  })));
};
/* harmony default export */ var quote = (SvgQuote);
// EXTERNAL MODULE: ./components/Image/style.module.scss
var Image_style_module = __webpack_require__(20027);
var Image_style_module_default = /*#__PURE__*/__webpack_require__.n(Image_style_module);
;// CONCATENATED MODULE: ./components/Image/index.tsx
/* eslint-disable react/jsx-boolean-value */ 







var defaultAlt = "Medrecruit Image";
var convertToArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
var RegisterImgStyle;
(function(RegisterImgStyle) {
    RegisterImgStyle["Img"] = "img";
    RegisterImgStyle["OverlayImage"] = "overlayImage";
})(RegisterImgStyle || (RegisterImgStyle = {}));
var ImageContainer = function(param) {
    var img = param.img, imgStyle = param.imgStyle, imgAlt = param.imgAlt, overlayCenteredText = param.overlayCenteredText, overlayTextInBox = param.overlayTextInBox, width = param.width, height = param.height, whiteBackground = param.whiteBackground;
    var text = overlayCenteredText || overlayTextInBox;
    var textStyle = overlayCenteredText ? (Image_style_module_default()).centeredText : (Image_style_module_default()).overlayCenteredTextInBox;
    var termsStyle = overlayTextInBox ? (Image_style_module_default()).greyText : overlayCenteredText ? (Image_style_module_default()).hidden : (Image_style_module_default()).whiteText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Image_style_module_default()).imgContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(imgStyle === RegisterImgStyle.OverlayImage ? (Image_style_module_default()).overlayImage : (Image_style_module_default()).img),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    priority: true,
                    width: width,
                    height: height,
                    src: img,
                    alt: imgAlt || defaultAlt,
                    title: imgAlt || defaultAlt
                })
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Image_style_module_default()).textContainer, textStyle, whiteBackground && (Image_style_module_default()).whiteBackground),
                children: [
                    overlayTextInBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(quote, {}),
                    convertToArray(text).map(function(text, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: overlayCenteredText ? "h4" : index === 0 ? "subtitle1" : "caption",
                            display: "block",
                            component: "p",
                            children: text
                        }, "".concat(text, "-").concat(index));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Image_style_module_default()).finePrint, termsStyle, whiteBackground && (Image_style_module_default()).paleBlueText),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SmallPrintTerms, {})
            })
        ]
    });
};


/***/ }),

/***/ 78219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L2": function() { return /* binding */ disableWeekends; },
/* harmony export */   "PN": function() { return /* binding */ parseAndFormatDate; },
/* harmony export */   "Zv": function() { return /* binding */ isSameOrBeforeCurrentDate; },
/* harmony export */   "e3": function() { return /* binding */ toIsoDateString; },
/* harmony export */   "i$": function() { return /* binding */ isWeekendDate; },
/* harmony export */   "iT": function() { return /* binding */ saleforceDateFormat; },
/* harmony export */   "qb": function() { return /* binding */ isValidDate; },
/* harmony export */   "sL": function() { return /* binding */ getTomorrow; }
/* harmony export */ });
/* unused harmony export isBeforeNow */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10285);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37412);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__);

// the customParseFormat is required for strict validation


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2___default()));
var isBeforeNow = function(dateTime) {
    var now = dayjs(new Date());
    return dayjs(dateTime).add(1, "day").isBefore(now);
};
var saleforceDateFormat = function(date) {
    return Intl.DateTimeFormat("en-NZ", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    }).format(date);
};
var toIsoDateString = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).toISOString();
};
var getTomorrow = function() {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "day");
};
/**
 * Performs a strict date validation against a given format
 * Checks if date is actually a valid one and in the right format
 */ var isValidDate = function(date, format) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, format, true).isValid();
};
/**
 * Converts an ISO date to given format
 * ! Will try to convert even invalid dates using native 'Date' object rules
 * For example '2022-02-31' will be converted to '2022-03-03'
 */ var parseAndFormatDate = function(dateToParse, format) {
    if (!dateToParse) {
        return null;
    }
    var dayjsDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateToParse);
    return dayjsDate.isValid() ? dayjsDate.format(format) : null;
};
//Identify weekends
var disableWeekends = function(date) {
    if (date && (date.getDay() == 0 || date.getDay() === 6)) {
        return true;
    }
    return false;
};
var isSameOrBeforeCurrentDate = function(date) {
    var now = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(new Date());
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).isSameOrBefore(now);
};
var isWeekendDate = function(date) {
    var day = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).day();
    return day === 0 || day === 6;
};


/***/ }),

/***/ 90664:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"style_white__ZTILG","publish":"style_publish__MR5PE","date":"style_date__uqaV4"};

/***/ }),

/***/ 30353:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__JbWMK","title":"style_title__vdmCk","blurb":"style_blurb__jUJdo","info":"style_info__cTwaz","containerBG":"style_containerBG__JeuG_","cover":"style_cover__zEI9F","image":"style_image__yacb0","topLeft":"style_topLeft__s5umm","link":"style_link__lPqKZ","Full_Width":"style_Full_Width__titMK","Full_Width_BG":"style_Full_Width_BG__Rezir","One_Column":"style_One_Column__38YNr","One_Column_BG":"style_One_Column_BG__QWguV","Two_Column":"style_Two_Column__qNDtb","Two_Column_BG":"style_Two_Column_BG__iewEG","Three_Column":"style_Three_Column__ke0Xk","Three_Column_BG":"style_Three_Column_BG__kyc0I"};

/***/ }),

/***/ 16944:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__71Iza","line":"style_line__3BDQT","bgImage":"style_bgImage__2A125","background":"style_background__SYqO5","Full_Width_BG":"style_Full_Width_BG__33Z_T","One_Column":"style_One_Column__EFLRN","One_Column_BG":"style_One_Column_BG__l_P5s","Two_Column":"style_Two_Column__Whn_T","Two_Column_BG":"style_Two_Column_BG__3Uk0y","Three_Column":"style_Three_Column__XQKSU","Three_Column_BG":"style_Three_Column_BG__Ywlz5"};

/***/ }),

/***/ 88460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContainer":"style_childrenContainer__d3pAq"};

/***/ }),

/***/ 8825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__hbsEY","bgColor":"style_bgColor__VvIIN","cover":"style_cover__LZ_nM","general":"style_general__8DPCV","article":"style_article__nsno9","testimonial":"style_testimonial__G_dCC","order":"style_order__LqMT8","link":"style_link__dsWTL","title":"style_title__uHcz0","publish":"style_publish__pT_8_","content":"style_content__jM45r","general_image_title":"style_general_image_title__YT2lv","quotes":"style_quotes__PRKJr","btnContainer":"style_btnContainer__Ygj8g","button":"style_button__3A6n_","linkText":"style_linkText__Ajuvi"};

/***/ }),

/***/ 84201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"others":"style_others__rj4Ao","articleSlides":"style_articleSlides__HjFBP","imageSlider":"style_imageSlider__4FBYj","arrowStyle":"style_arrowStyle__2YOk3","selected":"style_selected__w75Fa","unselected":"style_unselected__gZdoN","containerMarginS":"style_containerMarginS__XfK1z"};

/***/ }),

/***/ 88415:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerMarginL":"style_containerMarginL__Xin_m","containerMarginM":"style_containerMarginM__gcEkK","containerMarginS":"style_containerMarginS__uOEYv","containerPaddingS":"style_containerPaddingS__F37JV","markdownContent":"style_markdownContent__x1pNa"};

/***/ }),

/***/ 20027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"style_imgContainer__okrSE","img":"style_img__XGlaq","overlayImage":"style_overlayImage__JBqLw","textContainer":"style_textContainer__Amkh2","centeredText":"style_centeredText__2FA7k","overlayCenteredTextInBox":"style_overlayCenteredTextInBox__Fudym","finePrint":"style_finePrint__Jzs6x","whiteText":"style_whiteText__k32cQ","greyText":"style_greyText__NEUAp","hidden":"style_hidden__EqpuW","centeredImg":"style_centeredImg__t2PIR","droplets":"style_droplets__Y3htk","whiteBackground":"style_whiteBackground__ByG1F","paleBlueText":"style_paleBlueText__yr_OJ"};

/***/ }),

/***/ 10416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"smallPrint":"style_smallPrint__n1vZC"};

/***/ })

}]);